export const fetchSeries = (url) => {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Fail fetching data');
                }
                return response.json()
            })
            .then(data => resolve(data.data))
            .catch(err => reject(err));
    })
}

export const drawGauge = ({HighChart, value, element}) => {
    HighChart.chart(element, {
        chart: {
            type: 'gauge',
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false,
            height: 100,
            width: 198,
            backgroundColor: '#fde9d8'
        },
        credits: {
            enabled: false
        },
        title: {
            text: null
        },

        pane: {
            startAngle: -90,
            endAngle: 89.9,
            background: null,
            center: ['50%', '90%'],
            size: '200%'
        },

        yAxis: {
            min: 0,
            max: 100,
            tickPixelInterval: 72,
            tickPosition: 'inside',
            tickColor: HighChart.defaultOptions.chart.backgroundColor || '#FFFFFF',
            tickLength: 0,
            tickWidth: 2,
            minorTickInterval: null,
            labels: false,
            plotBands: [{
                from: 0,
                to: 20,
                color: '#CE1D1A',
                thickness: 10
            }, {
                from: 21,
                to: 40,
                color: '#FA840E',
                thickness: 10
            }, {
                from: 41,
                to: 60,
                color: '#E1CF2A',
                thickness: 10
            }, {
                from: 61,
                to: 80,
                color: '#88BC21',
                thickness: 10
            }, {
                from: 81,
                to: 100,
                color: '#00A632',
                thickness: 10
            }]
        },

        series: [{
            name: 'Score',
            data: [value],
            tooltip: false,
            dataLabels: {
                enabled: false
            },

            dial: {
                radius: '80%',
                backgroundColor: 'gray',
                baseWidth: 12,
                baseLength: '0%',
                rearLength: '0%'
            },
            pivot: {
                backgroundColor: 'gray',
                radius: 6
            }

        }]

    });
}

const scoreToConcept = (score) => {
    if (score > 8) return 'Muy fuerte';
    if (score > 6) return 'Fuerte';
    if (score > 4) return 'Neutral';
    if (score > 2) return 'Débil';
    else return 'Muy débil';
}

export const drawHighChartScore = ({HighChart, data, el}) => {

    // const score = data.score.map(item => ({value: item[1], time: item[0], color: scoreToColor(item[1])}));
    // console.log(score);

    const base = {
        navigator: {
            height: 30,
            margin: 50,
            enabled: true
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },

        chart: {
            renderTo: el,
            alignTicks: false,
            spacingTop: 15,
            zoomType: 'x',
            spacingBottom: 15,
            backgroundColor: '#fde9d8'
        },
        scrollbar: {
            enabled: true
        },

        rangeSelector: {
            selected: 2,
            buttonPosition: {
                align: 'left',
                x: -20,
                y: 0
            },

            inputPosition: {
                align: 'right',
                verticalAlign: 'top',
                floating: false,
                x: 0,
                y: 0
            }
        },

        title: {
            text: ''
        },

        plotOptions: {
            line: {
                lineWidth: 1
            }
        },
        series: [
            {
                id: 'cierres',
                dataGrouping: {
                    enabled: false
                },
                color: '#4572A7',
                yAxis: 0,
                name: 'Cierre Diario',
                data: data.last,
                tooltip: {
                    valueDecimals: 2
                }
            },
            {
                name: "Fuerza",
                id: 'puntuaciones',
                dataGrouping: {
                    enabled: false
                },
                color: '#FF071E',
                data: data.score,
                step: true,
                yAxis: 1,
                lineWidth: 2,
            }
        ],

        legend: {
            enabled: true,
            align: 'right',
            floating: false,
            margin: 20
        },

        tooltip: {
            split: true,
            formatter: function() {
                var points = this.points,
                    tooltipArray = [HighChart.dateFormat('%A, %e %b %Y',new Date(this.x))]

                points.forEach(function(point) {
                    const name = point.series.name;
                    const id = point.series.options.id;
                    const value = id && id === 'cierres' ? point.y : scoreToConcept(point.y);

                    tooltipArray.push(`${name}: <b>${value}</b>`);//index + '. VALUE: <b>' + point.y + '</b>');
                });

                return tooltipArray;
            }
        },

        xAxis: {
            gridLineWidth: 0,
            endOnTick: true
        },

        yAxis: [
            {
                labels: {
                    align: 'right',
                    x: -20,
                    style: {
                        color: '#4572A7',
                        fontWeight: 'bold'
                    }
                },
                title: {
                    text: 'Cierre Diario',
                    style: {
                        color: '#4572A7',
                        'font-weight': 'bold'
                    }
                },
                gridLineWidth: 0,
                maxPadding: 0.05,
                showLastLabel: true,
                endOnTick: false,
                opposite: false
            },
            {
                tickPositions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                labels: false,
                title: {
                    text: 'Fuerza',
                    style: {
                        color: '#FF071E',
                        'font-weight': 'bold'
                    }
                },
                plotBands: [
                    {
                        color: 'rgba(206, 29, 26, 0.2)',
                        from: 0,
                        to: 2
                    },
                    {
                        color: 'rgba(250, 132, 14, 0.2)',
                        from: 2.1,
                        to: 4
                    },
                    {
                        color: 'rgba(225, 207, 42, 0.2)',
                        from: 4.1,
                        to: 6
                    },
                    {
                        color: 'rgba(136, 188, 33, 0.2)',
                        from: 6.1,
                        to: 8
                    },
                    {
                        color: 'rgba(0, 166, 50, 0.2)',
                        from: 8.1,
                        to: 10
                    },
                ],
                endOnTick: true,
                showLastLabel: true,
                gridLineWidth: 1,
                gridLineDashStyle: 'dash',
                opposite: true
            }]
    };

    HighChart.setOptions({
        lang : {
            downloadPNG : 'Descargar como PNG',
            downloadJPEG : 'Descarga como JPEG',
            downloadPDF : 'Descargar como PDF',
            downloadSVG : 'Descargar como imagen de vectores SVG',
            exportButtonTitle : 'Descargar grafico',
            loading : 'Cargando...',
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            printButtonTitle : 'Imprimir grafico',
            rangeSelectorZoom: '',
            rangeSelectorFrom : 'De',
            rangeSelectorTo : 'A',
            resetZoom : 'Resetear Zoom',
            resetZoomTitle : 'Zoom a nivel 1:1',
            decimalPoint : ',',
            thousandsSep : '.'
        }
    });

    const chart = new HighChart.stockChart(base);
    chart.setSize(null);

    addEventListener('resize', _ => {
        const width = el.offsetWidth;
        chart.setSize(width);
    });

    return chart;
}